/*
 * @Author: luohongbiao
 * @Date: 2022-01-17 09:54:58
 * @LastEditTime: 2022-07-23 09:57:09
 * @LastEditors: LHB
 * @Description:
 * @FilePath: \shirleyClass\src\utils\config.js
 */
import shareImg from '../assets/images/share.png'

let config = {
  //  分享的小icon
  shareImgUrl: shareImg,
  // 分享活动_微信
  shareMainTitle: '雪梨英语课程平台',
  shareDesTitle: '输入下单信息开通课程，开始学习吧！',
  shareUrl:'https://static.xueliyingyu.com/fe/prod/shirleyClass/index.html#/',
  xfrom: 7,
  appId: 'wx18442ce144829bd5'
}

export default {
  config
}
